module.exports = __webpack_public_path__ + "static/media/04_b_content.dc4776c7.md";